<div
	class="result-item"
	[class.active]="isActive()"
	(click)="onSelect()"
	(keydown)="onKeyDown($event)"
	tabindex="0"
	role="button"
>
	<div class="result-item-content">
		@if (action().icon) {
			<div class="result-item-icon">
				<mat-icon [fontIcon]="action().icon"></mat-icon>
			</div>
		}

		<div class="result-item-text">
			<div class="result-item-label">
				@for (segment of highlightedLabel(); track $index) {
					@if (segment.matched) {
						<span class="highlight">{{ segment.char }}</span>
					} @else {
						<span>{{ segment.char }}</span>
					}
				}
			</div>
			@if (action().description) {
				<div class="result-item-description">
					{{ action().description }}
				</div>
			}
		</div>
	</div>
	@if (action().shortcut) {
		<div class="result-item-shortcut">
			<kbd>{{ action().shortcut }}</kbd>
		</div>
	}
</div>
